import { useMemo } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";

import { ProductTab } from "@views/shared/product-tab/product.tab";

import { ClassroomProgressCeTab } from "./classroom.progress.ce.tab";
import { ClassroomProgressDemoTab } from "./classroom.progress.demo.tab";
import { ClassroomProgressProgTab } from "./classroom.progress.prog.tab";
import { ClassroomProgressTrekTab } from "./classroom.progress.trek.tab";
import { ClassroomProgressTsTab } from "./classroom.progress.ts.tab";

export const ClassroomProgressTab = ({
  name,
  className,
  classroom,
  users,
  responsiveStyles,
  courseData,
  activityStatus,
  courseDataLoading,
}) => {
  const { products = [], isDemo } = classroom ?? {
    products: [],
    isDemo: false,
  };

  const progressTab = useMemo(() => {
    const tabs = {
      [Product.TS]: (
        <ClassroomProgressTsTab trainees={users} classroom={classroom} />
      ),
      [Product.CE]: (
        <ClassroomProgressCeTab classroom={classroom} explorers={users} />
      ),
      [Product.TRK]: (
        <ClassroomProgressTrekTab classroom={classroom} users={users} />
      ),
      [Product.PROG]: (
        <ClassroomProgressProgTab
          classroom={classroom}
          users={users}
          responsiveStyles={responsiveStyles}
          courseData={courseData}
          activityStatus={activityStatus}
          courseDataLoading={courseDataLoading}
        />
      ),
    };

    return products.reduce((acc, product) => {
      acc[product] = isDemo ? <ClassroomProgressDemoTab /> : tabs[product];
      return acc;
    }, {});
  }, [
    classroom,
    users,
    responsiveStyles,
    courseData,
    activityStatus,
    courseDataLoading,
    products,
  ]);

  return (
    <ProductTab
      name={name}
      className={className}
      productComponents={progressTab}
    />
  );
};
